import React from 'react';
import "../../../css/errorMessage.scss"

const ErrorMessage = ({className, errorMessage}) => {

    return (
        <div id='error-message-react' className={`error-message ${className}`}>
            {errorMessage}
        </div>)
}

export default ErrorMessage;